module.exports = __webpack_public_path__ + "bnbproject/img/kaka.482b8868.jpg";